import initReducers from './init';

// Reducers object
const reducers = {
  ...initReducers,
};

export default reducers;
